import { render, staticRenderFns } from "./ConfirmPopover.vue?vue&type=template&id=2f1297ea&scoped=true&"
import script from "./ConfirmPopover.vue?vue&type=script&lang=js&"
export * from "./ConfirmPopover.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmPopover.vue?vue&type=style&index=0&id=2f1297ea&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f1297ea",
  null
  
)

export default component.exports